import { IKeyAny } from "../api-client";
import { BaseApi } from "../base";

interface ICreateTagPayload {
  teamId: string;
  name: string;
}

interface IUpdateTagPayload {
  id: string;
  name: string;
}

function parseCreatePayload(payload: ICreateTagPayload): IKeyAny {
  const { teamId, name } = payload;
  return {
    teamID: teamId,
    name,
  };
}

function parseUpdatePayload(payload: IUpdateTagPayload): IKeyAny {
  return {
    name: payload.name,
  };
}

export default class TagApi extends BaseApi {
  protected readonly prefix = "tags";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (payload: ICreateTagPayload) => this.post("", parseCreatePayload(payload));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (payload: IUpdateTagPayload) => this.patch(payload.id, parseUpdatePayload(payload));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteTag = (id: string) => this.delete(id);
}
